<template>
  <div class="analyze">
    <img
      class="banner"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4d9f31f4b289c67dc2a0cc1fdae49289.png"
      alt=""
    />
    <div class="desc">
      <div>参考文献:</div>
      <div>[1]中国营养学会. 中国居⺠膳⻝指南[M]. 人⺠卫生出版社, 2022.</div>
      <div
        >[2]杨月欣 总主编,葛可佑 总主编著.中国营养科学全书(第二版
        全二册).人⺠卫生出版 社.2019:576.</div
      >
      <div
        >[3]. FAO, World Health Organization and United Nations University
        (2004). Human energy requirements.
      </div>
      <div
        >[4]. Mifflin, M., St Jeor, S., Hill, L., Scott, B., Daugherty, S. and
        Koh, Y. (1990). A new predictive equation for resting energy expenditure
        in healthy individuals. The American Journal of Clinical Nutrition,
        51(2), pp.241-247.</div
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.analyze {
  min-height: 100vh;
  background: #f9f9f9;
  padding: 16px 20px;
  box-sizing: border-box;

  .banner {
    width: 335px;
    height: 689px;
    margin: 0 auto;
    margin-bottom: 16px;
    object-fit: contain;
  }

  .content {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;

    .image {
      width: 100%;
      height: auto;
      margin-bottom: 16px;
    }

    .text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 26px;
    }
  }

  .desc {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.4);
    line-height: 18px;
  }
}
</style>
